import {classes} from './DetailsFormButtons.st.css';
import {Button, ButtonPriority, StatesButtonStates} from 'wix-ui-tpa/cssVars';
import {NextStepButton} from '../NextStepButton/NextStepButton';
import React from 'react';
import {useMemberDetailsData} from '../../../../MemberDetails/WithMemberDetailsData';
import {useLocaleKeys} from '../../../../../../locale-keys/LocaleKeys';
import {ADD_NEW_ADDRESS_ID} from '../../../../constants';
import {useControllerProps} from '../../../../Widget/ControllerContext';

export enum FormDetailsButtonsDataHook {
  continueButton = 'FormDetailsButtons.continue',
  cancelButton = 'FormDetailsButtons.cancel',
}

export interface DetailsFormButtonsProps {
  onCancel?: () => void;
  onContinue: () => void;
  continueButtonDisabled: boolean;
  continueButtonState: StatesButtonStates;
  shouldIncludeCancelButton?: boolean;
  label?: string;
}
export const DetailsFormButtons = ({
  onCancel,
  onContinue,
  continueButtonDisabled,
  continueButtonState,
  shouldIncludeCancelButton = true,
  label,
}: DetailsFormButtonsProps) => {
  const localeKeys = useLocaleKeys();

  const {
    memberStore: {addressesInfo, isMember, isAddressesAppInstalled, defaultAddressId},
  } = useControllerProps();

  const {
    setEditMode,
    editMode,
    selectedAddressesServiceId,
    resetMemberDetailsState,
    setAddressServiceById,
    isAddNewChecked,
  } = useMemberDetailsData();
  const onCancelAction = () => {
    if (editMode) {
      setEditMode(false);
    } else if (selectedAddressesServiceId === ADD_NEW_ADDRESS_ID) {
      resetMemberDetailsState({isInitSelectValue: true});
    } else {
      setEditMode(false);
      setAddressServiceById(defaultAddressId);
    }
    onCancel?.();
  };

  const getContinueButtonText = (): string => {
    if (label) {
      return label;
    }
    return editMode || isAddNewChecked || selectedAddressesServiceId === ADD_NEW_ADDRESS_ID
      ? localeKeys.checkout.saveAndContinue.cta()
      : localeKeys.checkout.continue_button_label();
  };

  const isMemberWithoutAddressServiceId = isMember && isAddressesAppInstalled && !selectedAddressesServiceId;
  const shouldShowCancelButton =
    shouldIncludeCancelButton &&
    (isMemberWithoutAddressServiceId || editMode || selectedAddressesServiceId === ADD_NEW_ADDRESS_ID) &&
    addressesInfo.addresses.length > 0;

  return (
    <div className={classes.buttonsWrapper}>
      {shouldShowCancelButton && (
        <Button
          data-hook={FormDetailsButtonsDataHook.cancelButton}
          priority={ButtonPriority.basicSecondary}
          className={classes.cancelButton}
          onClick={onCancelAction}
          wrapContent
          upgrade>
          {isMemberWithoutAddressServiceId
            ? localeKeys.checkout.chooseNewAddress.cta()
            : localeKeys.checkout.cancel.cta()}
        </Button>
      )}
      <NextStepButton
        onClick={onContinue}
        text={getContinueButtonText()}
        dataHook={FormDetailsButtonsDataHook.continueButton}
        disabled={continueButtonDisabled}
        buttonState={continueButtonState}
      />
    </div>
  );
};
